module.exports = __webpack_public_path__ + "static/media/hm.e875a51e.svg";